import { IServerAdminSettings } from '../../../settings/types/ISite';
import { Request } from './Request';

export interface IUpdateSiteSettingsForServerAdminParams {
  id: string;
  settings: IServerAdminSettings;
}

export interface IUpdateSiteSettingsForServerAdminResult {
}

export class UpdateSiteSettingsForServerAdminRequest extends Request<IUpdateSiteSettingsForServerAdminParams, IUpdateSiteSettingsForServerAdminResult> {
  constructor(params: IUpdateSiteSettingsForServerAdminParams) {
    super('updateSiteSettingsForServerAdmin', params);
  }
}
